export default {
      id: "icon-admin-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-admin",
      toString: function () {
        return this.url;
      }
    }